import { LayoutType } from '../types/layouts.esm.js';

function getCustomLayout(layouts) {
  return layouts === null || layouts === void 0 ? void 0 : layouts.find(function (l) {
    return l.type === LayoutType.Custom;
  });
}

export { getCustomLayout };
//# sourceMappingURL=get-custom-layout.esm.js.map
